import { createFileRoute, Navigate } from '@tanstack/react-router';
import { getDailyFaresQueryOptions, getFaresQueryOptions } from '../../../features/patient-transport/queries';

export const Route = createFileRoute('/_auth/patient-transport/fares/')({
  loader: ({ context: { queryClient, authenticationContext } }) => {
    if (!authenticationContext.user?.porter) {
      return undefined;
    }
    return [
      queryClient.ensureQueryData(getFaresQueryOptions(authenticationContext.user.porter)),
      queryClient.ensureQueryData(getDailyFaresQueryOptions()),
    ];
  },
  component: () => <Navigate to="/patient-transport/fares/active" />,
});
